import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { onGetNotification } from "./NotificationThunk";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";

interface SettingsState {
	isLoading: boolean;
	notificationAlert: InfoNotificationAdmin[];
	error?: string;
}

const initialState: SettingsState = {
	isLoading: false,
	notificationAlert: [],
	error: undefined,
};

const notificationSlice = createSlice({
	name: "notification",
	initialState,
	reducers: {

	},
	extraReducers: (builder) => {
		builder
			.addCase(onGetNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onGetNotification.fulfilled,
				(state, action: PayloadAction<InfoNotificationAdmin[]>) => {
					state.isLoading = false;
					state.notificationAlert = action.payload;
				}
			)
			.addCase(onGetNotification.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			});
	},
});

export default notificationSlice.reducer;
